import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { articlesLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useArticlesLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'articles' }));
    return onSnapshot(
      collection(db, 'articles'),
      querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        dispatch(articlesLoadedAction(items));
      },
      error => {
        console.error('useArticlesLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadArticles: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useArticlesLoader;
